import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const DirectRoutingDialPlansField = ({
    value,
    onChange,
    options,
    darkMode,
    error,
    showError,
    disableStackHeight,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const selectedIds = Array.isArray(value)
        ? value.map((item) => item.id)
        : [];

    const handleSelectChange = (ids) => {
        const selected = (ids || [])
            .map((id) => (options || []).find((option) => option.id === id))
            .filter(Boolean);
        onChange(selected);
    };

    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={
                    disableStackHeight
                        ? { width: '775px' }
                        : {
                              ...stackStyling(true),
                              height: 'auto',
                          }
                }
                width="100%">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Dial Plans <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select one or more dial plans for this service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <DropDown
                        name="dialPlans"
                        isMulti
                        data={options}
                        shownValue="name"
                        multiValue={selectedIds}
                        walkthroughId={
                            walkthroughIds.serviceProfiles?.ufDialPlansSelect
                        }
                        placeholder="- Select Dial Plans -"
                        darkMode={darkMode}
                        width="100%"
                        handleSelectChange={handleSelectChange}
                    />
                    {showError && (
                        <Text
                            color="red.500"
                            fontSize="xs"
                            mt={1}
                            textAlign="right">
                            {error}
                        </Text>
                    )}
                </Box>

                {isHovered && (
                    <FieldToolTip
                        label="Select one or more dial plans for this service."
                        ariaLabel="dr-dialplans-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DirectRoutingDialPlansField;
